import API from '../apiCreate'
import { getParams } from '../getParams'
import { ResponseNumber, ResponseWrapper } from '../types/base.types'
import {
  RequestChangeLicense,
  RequestRenewLicense,
  ResponseLicenseAndPayment,
  ResponsePayment,
  ResponseMetricsGraduationData,
  ResponseGetPriceParam,
  ResponseGetPrice,
  RequestGetPriceParam,
  ResponsePaymentHistory,
  LicenseCompanyDetails,
  ResponseCompanyDetails,
  CompanyLookupResult,
  BankLookupResult,
  ResponseBillingDocuments,
  ResponseCreateInvoice,
  // RequestPriceForPayment,
} from '../types/licenseAndPayment.types'

export const licenseAndPaymentApi = {
  getData: () =>
    API.get<ResponseLicenseAndPayment>('license-and-payment/get-data'),

  getPaymentHistory: () =>
    API.get<ResponsePaymentHistory>('license-and-payment/get-payment-history'),

  getCompanyDetails: () =>
    API.get<ResponseCompanyDetails>('license-and-payment/get-company-details'),

  saveCompanyDetails: (data: LicenseCompanyDetails) =>
    API.post<ResponseCompanyDetails>(
      'license-and-payment/save-company-details',
      data,
    ),

  lookupCompany: (inn: string) =>
    API.post<ResponseWrapper<CompanyLookupResult>>(
      'license-and-payment/lookup-company',
      { inn },
    ),

  lookupBank: (bik: string) =>
    API.post<ResponseWrapper<BankLookupResult>>(
      'license-and-payment/lookup-bank',
      { bik },
    ),

  getBillingDocuments: () =>
    API.get<ResponseBillingDocuments>(
      'license-and-payment/get-billing-documents',
    ),

  createInvoice: (data: Pick<RequestRenewLicense, 'metrics' | 'months'>) =>
    API.post<ResponseCreateInvoice>('license-and-payment/create-invoice', data),

  downloadInvoice: (id: number) =>
    API.get<Blob>(`license-and-payment/download-invoice?id=${id}`, {
      responseType: 'blob',
    }),

  downloadAct: (id: number) =>
    API.get<Blob>(`license-and-payment/download-act?id=${id}`, {
      responseType: 'blob',
    }),

  getMetricsGraduationData: () =>
    API.get<ResponseMetricsGraduationData>(
      'license-and-payment/get-metrics-graduation-data',
    ),

  // FIXME: удалить цену из payload (цена должна считаться на бэке)
  renewLicense: (data: RequestRenewLicense) =>
    API.post<ResponsePayment>('license-and-payment/renew-license', data),

  changeLicense: (data: RequestChangeLicense) =>
    API.post<ResponsePayment>('license-and-payment/change-license', data),

  // deprecated
  // getPriceForPayment: (data: RequestPriceForPayment) =>
  //   API.post<ResponseNumber>('license-and-payment/get-price-for-payment', data),

  // используется для получения цены при renewLicense
  getPrice: (data: Pick<RequestRenewLicense, 'metrics' | 'months'>) =>
    API.post<ResponseGetPrice>('license-and-payment/get-price', data),

  // используется для получения цены при changeLicense
  getPriceParam: (data: RequestGetPriceParam) =>
    API.post<ResponseGetPriceParam>(
      'license-and-payment/get-price-param',
      data,
    ),

  checkPayment: (params: { id: number }) =>
    API.get<ResponseNumber>( // response data =    1 = 'success' | 0 = 'process'
      `license-and-payment/check-payment/${getParams(params)}`,
    ),
}
